import React from 'react';
import './index.scss';

export default function LanguageList({ action, languages = [] }) {
  return (
    <div className={'landingSwitch-language'}>
      <div className={'languages-list'}>
        {languages.map((item, index) => {
          return (
            <span
              onClick={() => action(item.language)}
              aria-roledescription={'button'}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>
    </div>
  );
}
